import CustomToast from "components/custom-toast"
import { toast } from "react-toastify"
import DEBUG from "./IsDebugOn"
import NotEmpty from "./NotEmpty"

export default class ApiV2 {
  /**
   * @typedef ResponseApi
   * @type {object}
   * @property {object} data
   * @property {boolean} sucesso
   * @property {string[]} erros
   */

  /**
   * @typedef {(function|((...args: any[]) => Promise<any>))} MaybeAsyncFunction
   */

  /**
   * @param {function} apiFunction
   * @param {string[]} params
   * @param {function} loader
   * @param {string} titleError
   * @param {string} messageError
   * @param {MaybeAsyncFunction} [callbackError]
   * @param {MaybeAsyncFunction} [callbackSuccess]
   * @returns {Promise<any[]|any|void>}
   */
  async get(apiFunction, params, loader, titleError, messageError, callbackError = null, callbackSuccess = null) {
    loader(true)
    try {
      /**
       * @type {ResponseApi}
       */
      const resp = await apiFunction(...params)
      if (resp?.sucesso) {
        if (callbackSuccess) await callbackSuccess(resp)
        else {
          loader(false)
          return resp
        }
      } else {
        if (callbackError) await callbackError(resp)
        else {
          if (DEBUG()) console.log(resp)
          if ((NotEmpty(titleError) && NotEmpty(messageError)) || NotEmpty(resp?.erros)) {
            toast.error(
              <CustomToast
                title={titleError}
                message={resp.erros.join("; ") || messageError}
              />
            )
          }
        }
      }
    } catch (error) {
      if (DEBUG()) console.log(error)
      if (callbackError) {
        loader(false)
        return await callbackError({ data: {}, sucesso: false, erros: [error.message || "Erro na solicitação!"] })
      }
      if (NotEmpty(titleError) && NotEmpty(messageError)) {
        toast.error(
          <CustomToast
            title={titleError}
            message={messageError}
          />
        )
      }
    }
    loader(false)
  }

  /**
   * @param {function} apiFunction
   * @param {string[]} params
   * @param {object} body
   * @param {function} loader
   * @param {string} titleError
   * @param {string} messageError
   * @param {MaybeAsyncFunction} [callbackError]
   * @param {MaybeAsyncFunction} [callbackSuccess]
   * @returns {Promise<any[]|any|void>}
   */
  async post(apiFunction, params, body, loader, titleError, messageError, callbackError = null, callbackSuccess = null) {
    loader(true)
    try {
      /**
       * @type {ResponseApi}
       */
      const resp = await apiFunction(...params, body)
      if (resp?.sucesso) {
        if (callbackSuccess) await callbackSuccess(resp)
        else {
          loader(false)
          return resp
        }
      } else {
        if (callbackError) await callbackError(resp)
        else {
          if (DEBUG()) console.log(resp)
          if (((NotEmpty(titleError) && NotEmpty(messageError)) || NotEmpty(resp?.erros))) {
            toast.error(
              <CustomToast
                title={titleError}
                message={resp.erros.join("; ") || messageError}
              />
            )
          }
        }
      }
    } catch (error) {
      if (DEBUG()) console.log(error)
      if (callbackError) {
        loader(false)
        return await callbackError({ data: {}, sucesso: false, erros: [error.message || "Erro na solicitação!"] })
      }
      if (NotEmpty(titleError) && NotEmpty(messageError)) {
        toast.error(
          <CustomToast
            title={titleError}
            message={messageError}
          />
        )
      }
    }
    loader(false)
  }

  /**
   * @param {function} apiFunction
   * @param {string[]} params
   * @param {object} body
   * @param {function} loader
   * @param {string} titleError
   * @param {string} messageError
   * @param {MaybeAsyncFunction} [callbackError]
   * @param {MaybeAsyncFunction} [callbackSuccess]
   * @returns {Promise<any[]|any|void>}
   */
  async put(apiFunction, params, body, loader, titleError, messageError, callbackError = null, callbackSuccess = null) {
    loader(true)
    try {
      /**
       * @type {ResponseApi}
       */
      const resp = await apiFunction(...params, body)
      if (resp?.sucesso) {
        if (callbackSuccess) await callbackSuccess(resp)
        else {
          loader(false)
          return resp
        }
      } else {
        if (callbackError) await callbackError(resp)
        else {
          if (((NotEmpty(titleError) && NotEmpty(messageError)) || NotEmpty(resp?.erros))) {
            toast.error(
              <CustomToast
                title={titleError}
                message={resp.erros.join("; ") || messageError}
              />
            )
          }
        }
      }
    } catch (error) {
      if (DEBUG()) console.log(error)
      if (callbackError) {
        loader(false)
        return await callbackError({ data: {}, sucesso: false, erros: [error.message || "Erro na solicitação!"] })
      }
      if (NotEmpty(titleError) && NotEmpty(messageError)) {
        toast.error(
          <CustomToast
            title={titleError}
            message={messageError}
          />
        )
      }
    }
    loader(false)
  }

  /**
   * @param {function} apiFunction
   * @param {string[]} params
   * @param {function} loader
   * @param {string} titleError
   * @param {string} messageError
   * @param {MaybeAsyncFunction} [callbackError]
   * @param {MaybeAsyncFunction} [callbackSuccess]
   * @returns {Promise<any[]|any|void>}
   */
  async delete(apiFunction, params, loader, titleError, messageError, callbackError = null, callbackSuccess = null) {
    loader(true)
    try {
      /**
       * @type {ResponseApi}
       */
      const resp = await apiFunction(...params)

      if (resp?.sucesso) {
        if (callbackSuccess) await callbackSuccess(resp)
        else {
          loader(false)
          return resp
        }
      } else {
        if (callbackError) await callbackError(resp)
        else {
          if (DEBUG()) console.log(resp)
          if (((NotEmpty(titleError) && NotEmpty(messageError)) || NotEmpty(resp?.erros))) {
            toast.error(
              <CustomToast
                title={titleError}
                message={resp.erros.join("; ") || messageError}
              />
            )
          }
        }
      }
    } catch (error) {
      if (DEBUG()) console.log(error)
      if (callbackError) {
        loader(false)
        return await callbackError({ data: {}, sucesso: false, erros: [error.message || "Erro na solicitação!"] })
      }
      if (NotEmpty(titleError) && NotEmpty(messageError)) {
        toast.error(
          <CustomToast
            title={titleError}
            message={messageError}
          />
        )
      }
    }
    loader(false)
  }
}
